import { render, staticRenderFns } from "./Logiciel.vue?vue&type=template&id=172b1ef8&"
import script from "./Logiciel.vue?vue&type=script&lang=js&"
export * from "./Logiciel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports